module.exports = __webpack_public_path__ + "img/si.54ff28f.svg";